module.exports = __webpack_public_path__ + "img/icwithdraw.7690e0b0.png";